module.exports = __webpack_public_path__ + "static/media/milind-desai.1dad6158.jpg";